'use client'
import React from 'react'

import BreadCrumbs from '../../sections/breadcrumbs'
import SkewedCta from '../../sections/skewedCta'
import Article from '../../sections/article'
import EventCalendarHome from '../../sections/eventsCalendarHome'

const NewsDetailsPage = ({
  intro_text,
  body,
  lists,
  footer,
  header,
  breadcrumbs,
  get_snel_naar,
  cta,
  header_image,
  contact,
  events = [],
}) => {
  const article = [...intro_text, ...body]
  const link = get_snel_naar?.length && get_snel_naar[0].value
  const ctaData = cta?.length && cta[0].value

  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={88} widthVariant="full" />

      <Article article={article} lists={lists} link={link} />

      {ctaData ? (
        <SkewedCta
          title={ctaData.link?.text}
          text={ctaData.text}
          href={ctaData?.link?.href || ctaData?.link?.external_url}
          image={ctaData?.image}
          addShadow={false}
          padding={95}
        />
      ) : null}

      {events.length > 0 && (
        <EventCalendarHome
          title="Gerelateerde evenementen"
          events={events}
          hideButton={true}
        />
      )}
    </>
  )
}

export default NewsDetailsPage
